<div class="row">
    <div class="col-12" style="margin-top: 100px;">

    </div>
</div>

<section class="">
    <div class="container-xl">
        <div class="row mt-5 mb-5 justify-content-center">
            <div class="col-md-4 card-fit">
                <div class="card">
                    <div class="card-header card-header-first">
                        <div class="row">
                            <div class="col-8">
                                <p class="standard">Standard Plan</p>
                            </div>
                            <div class="col-4">
                                <p class="text">AED 475</p>
                                <p class="word">+5% VAT</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <p class="shade">Get genuine house owner contacts matching your requirements</p>

                        <div class="row mt-2">
                            <div class="col-12">
                                <p class="space bold">Complete Relocation Assistance on Call</p>
                                <ul class="list">
                                    <li>Free Customized Packer and Mover Quote</li>
                                    <li>Free Rental Agreement consultation with expert</li>
                                    <li>On-Demand Support</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Premium Filters</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Number of Units/Property</p>
                            </div>
                            <div class="col-2 text-end">
                                <p class="bold list">Upto 25</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Instant Property Alerts on SMS/whatsapp</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Dedicated Relationship Manager</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-close symbole"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Plan Validity</p>
                            </div>
                            <div class="col-2 text-end">
                                <p class="bold list">15 Days</p>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="button" class="btn subscribe ">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="col-md-4 card-fit">
                <div class="card">
                    <div class="card-header head">
                        <div class="row">
                            <div class="col-8">
                                <p class="mt-3">Premium Plan</p>
                            </div>
                            <div class="col-4">
                                <p class="text">AED 875</p>
                                <p class="word">+5% VAT</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <p class="genuine">Get Relationship Manager to help you SAVE time and money</p>

                        <div class="row">
                            <div class="col-12">
                                <p class="space bold">Relationship Manager</p>
                                <ul class="list">
                                    <li>Contacts owners and fixes meetings</li>
                                    <li>Negotiates rent on your behalf</li>
                                    <li> Provides locality level expertise</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Premium Filters</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Number of Units/Property</p>
                            </div>
                            <div class="col-2 text-end">
                                <p class="bold list">Unlimited</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Instant Property Alerts on SMS/whatsapp</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Dedicated Relationship Manager</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Plan Validity</p>
                            </div>
                            <div class="col-2 text-end">
                                <p class="bold list">30  Days</p>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="button" class="btn subscribe-select ">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

